var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 26C8 22.6863 10.6863 20 14 20H50C53.3137 20 56 22.6863 56 26V34H8L8 26Z",
    fill: "url(#paint0_linear_328_683)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8C10 5.79086 11.7909 4 14 4H46C48.2091 4 50 5.79086 50 8V50C50 52.2091 48.2091 54 46 54H14C11.7909 54 10 52.2091 10 50V8Z",
    fill: "url(#paint1_linear_328_683)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14C18 11.7909 19.7909 10 22 10H50C52.2091 10 54 11.7909 54 14V50C54 52.2091 52.2091 54 50 54H22C19.7909 54 18 52.2091 18 50V14Z",
    fill: "url(#paint2_linear_328_683)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C12 17.7909 13.7909 16 16 16H48C50.2091 16 52 17.7909 52 20V50C52 52.2091 50.2091 54 48 54H16C13.7909 54 12 52.2091 12 50V20Z",
    fill: "url(#paint3_linear_328_683)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23C30 22.4477 29.5523 22 29 22H19C18.4477 22 18 22.4477 18 23C18 23.5523 18.4477 24 19 24H29C29.5523 24 30 23.5523 30 23Z",
    fill: "url(#paint4_linear_328_683)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27C26 26.4477 25.5523 26 25 26H19C18.4477 26 18 26.4477 18 27C18 27.5523 18.4477 28 19 28H25C25.5523 28 26 27.5523 26 27Z",
    fill: "url(#paint5_linear_328_683)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 34C8 32.8954 8.89543 32 10 32H54C55.1046 32 56 32.8954 56 34V54C56 57.3137 53.3137 60 50 60H14C10.6863 60 8 57.3137 8 54V34Z",
    fill: "url(#paint6_linear_328_683)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44C22 42.8954 22.8954 42 24 42H40C41.1046 42 42 42.8954 42 44C42 45.1046 41.1046 46 40 46H24C22.8954 46 22 45.1046 22 44Z",
    fill: "url(#paint7_linear_328_683)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_328_683",
    x1: 56,
    y1: 34,
    x2: 48.4736,
    y2: 8.1952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#566C80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_328_683",
    x1: 50,
    y1: 54,
    x2: 1.21951,
    y2: 14.9756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5200FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906064,
    stopColor: "#0085FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_328_683",
    x1: 54,
    y1: 54,
    x2: 10.8713,
    y2: 18.7129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377885,
    stopColor: "#FF7E07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE607"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_328_683",
    x1: 52,
    y1: 54,
    x2: 14.0499,
    y2: 14.0526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.295664,
    stopColor: "#71706E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9AA99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_328_683",
    x1: 21.75,
    y1: 22,
    x2: 21.75,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_328_683",
    x1: 20.5,
    y1: 26,
    x2: 20.5,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_328_683",
    x1: 56,
    y1: 60,
    x2: 31.6269,
    y2: 18.2176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126759,
    stopColor: "#2E2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877369,
    stopColor: "#566C80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_328_683",
    x1: 40.6957,
    y1: 46,
    x2: 40.6957,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.340681,
    stopColor: "#2E2E41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#566C80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesMoney);
export default __webpack_public_path__ + "static/media/filesMoney.d35e349802e4ada8c084ab6e41b45447.svg";
export { ForwardRef as ReactComponent };